import { action, computed, observable } from 'mobx';
import type { RootStore } from './root.store';
import { IFlowGalleryTemplate } from '~/components/FlowGallery/types/flow-gallery.types';

export class QuickPreviewUiStore {
    @observable currTemplate: IFlowGalleryTemplate = null;
    @observable templates: IFlowGalleryTemplate[] = null;
    @observable source: string;

    rootStore: RootStore = null;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    @computed
    get currTemplateIndex() {
        return this.templates?.findIndex(
            ({ _id }) => _id === this.currTemplate._id
        );
    }

    @computed
    get prevTemplate() {
        const prevIndex = this.currTemplateIndex - 1;
        return prevIndex > -1 ? this.templates[prevIndex] : null;
    }

    @computed
    get nextTemplate() {
        const nextIndex = this.currTemplateIndex + 1;
        return nextIndex < this.templates?.length
            ? this.templates[nextIndex]
            : null;
    }

    @action.bound
    loadQuickPreviewById(
        templateId: string,
        templates: IFlowGalleryTemplate[]
    ) {
        if (templates) {
            this.templates = templates;
        }
        this.setCurrTemplateId(templateId);
    }

    @action.bound
    resetQuickPreview() {
        this.templates = null;
        this.setCurrTemplateId(null);
    }

    @action.bound
    setCurrTemplateId(templateId: string) {
        this.currTemplate = this.templates?.find(
            ({ _id }) => _id === templateId
        );
    }

    @action.bound
    setQuickPreviewSource(source: string) {
        this.source = source;
    }
}
